
<template>
  <PreviewModal>
    <div v-if="restaurant?.id === restId && restaurant?.name">
      <div class="aspect-video bg-sand relative z-40">
        <AtomImage class="object-cover" :src="useCloudinaryImage(restaurant.cover, 900, 600)" :alt="restaurant.name" />
      </div>
      <div class="p-4 md:px-6 grid gap-8">
        <div class="grid gap-2">
          <div class="grid gap-1">
            <h2 class="font-heading font-medium text-2xl md:text-3xl lg:text-4xl" v-html="restaurant.name" />
            <div class="flex items-center gap-2">
              <AtomIcon name="location-dot" class="text-coral" />
              <p class="bg-mist px-2 rounded-full text-xs py-0.5 border" v-if="restaurant.distance">{{ restaurant.distance }}km</p>
              <p class="text-sm opacity-60 line-clamp-1" v-html="[restaurant.address, restaurant.city].join(', ')" />
            </div>
          </div>
          <p class="font-bold leading-tight" v-html="restaurant.shortDescription" v-if="restaurant.shortDescription" />
          <p class="text-sm" v-html="restaurant.longDescription" v-if="!meal?.id" />
          <!-- CTA (book table & giftcards) -->
          <div class="mt-4" v-if="!meal?.id">
            <div class="flex items-center gap-4 text-sm max-w-sm">
              <button class="button-coral w-1/2" @click="useOpenWidget(restaurant.hash)">{{ $t('shared.bookTable') }}</button>
              <button class="button-coral-outline w-1/2" @click="useOpenWidget(restaurant.hash)" v-if="!meal?.id && restaurant.settings?.giftcardsEnabled">{{ $t('shared.buyGiftcard') }}</button>
            </div>
          </div>
          <p class="text-sm flex items-center gap-2 mt-4">
            <AtomIcon name="circle-chevron-right" class="text-coral" />
            <NuxtLink class="underline decoration-coral" :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}">
              {{ $t('shared.moreAboutRest', { name: restaurant?.name }) }}
            </NuxtLink>
          </p>
          <hr class="my-2">
        </div>
        <!-- EVENT MODAL -->
        <div v-if="!!meal?.id">
          <RestaurantEvent :restaurant="restaurant" :meal="meal" />
        </div>
        <!-- RESTAURANT MODAL -->
        <div class="grid gap-8" v-if="!meal?.id">
          <RestaurantFatMeals :restaurant="restaurant" v-if="route.name === 'fat'" />
          <RestaurantMeals :restaurant="restaurant" v-else />
          <RestaurantOpeningHours :restaurant="restaurant" />
          <RestaurantMap :restaurant="restaurant" />
          <RestaurantContact :restaurant="restaurant" />
          <!-- WIP -->
          <!-- <RestaurantDishes :restaurant="restaurant" class="box" /> -->
          <!-- <RestaurantImages :restaurant="restaurant" class="box" /> -->
          <!-- <RestaurantMenus :restaurant="restaurant" class="box" /> -->
        </div>
        <!-- <h2 class="font-bold text-xl" v-html="restaurant?.name" /> -->
        <!-- <div v-if="mealId">
          <p v-html="meal?.name" />
          <p v-html="meal?.description" />
        </div>
        <div v-else>
          <p v-html="restaurant?.shortDescription" />
          <p v-html="restaurant?.longDescription" />
        </div> -->
      </div>
    </div>
  </PreviewModal>
</template>

<script setup>
const route = useRoute()
const restId = ref(null)
const mealId = ref(null)
const restaurant = ref(null)

// Grep meals and meal from payload
const meals = computed(() => restaurant.value?.meals)
const meal = computed(() => meals.value?.find(meal => meal?.id === mealId.value))

// Update rest ID and meal ID references
const updateRefIds = () => {
  // if (route.query?.restId) {
  restId.value = parseInt(route.query?.restId) || undefined
  mealId.value = parseInt(route.query?.mealId) || undefined
  // }
}

// Fetch restaurant data from API and update restaurant ref
const fetchRestaurant = async () => {
  if (restId.value) {
    const payload = await $fetch(`/restaurants/${restId.value}`, {
      key: 'preview-payload',
      baseURL: useEnv('apiBase')
    })
    restaurant.value = payload?.data
  }
}

// Check rest ID and meal ID on mounted
onMounted(() => {
  updateRefIds()
  fetchRestaurant()
})

// Watch route changes to update rest ID and meal id
watch(() => route.query, () => {
  const restTrigger = route.query?.restId && parseInt(route.query?.restId) !== restId.value
  const mealTrigger = route.query?.mealId && parseInt(route.query?.mealId) !== mealId.value
  
  if (restTrigger || mealTrigger) {
    updateRefIds()
    fetchRestaurant()
  }
})
</script>

<style lang="scss" scoped>
// 
</style>